export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="126" height="27" viewBox="0 0 126 27" fill="none">
            <path
                d="M71.0651 13.897H61.9104L64.6838 3.51953H61.976L59.1648 14.0079C58.7916 15.3996 59.6186 16.5291 61.0103 16.5291H73.0619L76.5463 3.51953H73.8384L71.0651 13.897Z"
                fill="white"
            />
            <path
                d="M105.296 11.3883C106.688 11.3883 108.12 10.2588 108.493 8.86709L109.249 6.04077C109.622 4.64653 108.795 3.51953 107.404 3.51953H95.3018L94.5757 6.22734H106.526L105.868 8.678H93.9201L91.8174 16.5291H94.4547L95.8312 11.3883H99.2828L103.044 16.5291H106.882L103.138 11.3883H105.296Z"
                fill="white"
            />
            <path
                d="M122.115 3.51953H112.07L108.583 16.5291H118.628C121.134 16.5291 123.708 14.497 124.382 11.9909L125.436 8.05524C126.106 5.54913 124.619 3.51953 122.115 3.51953ZM121.795 11.8018C121.456 12.9477 120.432 13.7558 119.238 13.8188H111.927L113.961 6.23239H121.273C122.387 6.23239 123.038 7.135 122.75 8.24939L121.795 11.8018Z"
                fill="white"
            />
            <path
                d="M49.7151 3.51953C47.209 3.51953 44.6323 5.53653 43.9617 8.05777L42.9078 11.9934C42.2346 14.4995 43.7222 16.5317 46.2283 16.5317H56.2703L58.3731 8.68808H55.7384L54.3643 13.8213H47.0527C45.9383 13.8213 45.2878 12.9162 45.5778 11.8043L46.5308 8.24686C46.8692 7.1005 47.8937 6.29216 49.0873 6.22987H59.0185L59.7446 3.51953H49.7151Z"
                fill="white"
            />
            <path d="M84.5459 3.51709L74.292 16.5267H77.2746L85.1107 6.58796L87.6168 16.5267H90.5994L87.3193 3.51709H84.5459Z" fill="white" />
            <path d="M33.158 11.3757H40.4368L41.1604 8.67041H33.884L33.158 11.3757Z" fill="white" />
            <path d="M17.8617 0H10.5249L16.9339 8.67561L21.6133 5.07274L17.8617 0Z" fill="white" />
            <path d="M25.3446 20.044H32.684L26.8019 12.0845L21.7393 15.168L25.3446 20.044Z" fill="white" />
            <path d="M39.4057 0H30.1855L14.2411 12.228H17.7331L0.112061 27L30.2964 8.66551H26.7666L39.4057 0Z" fill="url(#paint0_linear_540_1528)" />
            <defs>
                <linearGradient id="paint0_linear_540_1528" x1="37.2323" y1="-1.72387e-07" x2="0.174831" y2="26.9788" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
